import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import Link from "next/link";
import Image from "next/image";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveLeaderboardDropAuthorProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropAuthor: React.FC<WaveLeaderboardDropAuthorProps> = t0 => {
  const $ = _c(31);
  const {
    drop
  } = t0;
  const t1 = `/${drop.author.handle}`;
  let t2;
  if ($[0] !== drop.author.pfp) {
    t2 = <div className="tw-h-11 tw-w-11 tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-lg">{drop.author.pfp ? <div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden"><Image src={resolveIpfsUrlSync(drop.author.pfp)} alt="Profile picture" width={44} height={44} className="tw-rounded-lg tw-object-contain" /></div></div></div> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />}</div>;
    $[0] = drop.author.pfp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link href={t1} onClick={_temp} className="tw-flex tw-items-center tw-gap-x-2 tw-no-underline group">{t2}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.author.level) {
    t4 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[5] = drop.author.level;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = drop.author.handle ?? drop.author.id;
  const t6 = `/${drop.author.handle}`;
  let t7;
  if ($[7] !== drop.author.handle) {
    t7 = <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author.handle}</span>;
    $[7] = drop.author.handle;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <Link href={t6} onClick={_temp2} className="tw-no-underline">{t7}</Link>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <UserProfileTooltipWrapper user={t5}>{t8}</UserProfileTooltipWrapper>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-size-[3px] tw-bg-iron-900 tw-rounded-full tw-flex-shrink-0" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== drop.created_at) {
    t11 = <WaveDropTime timestamp={drop.created_at} />;
    $[16] = drop.created_at;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t4 || $[20] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2">{t4}{t9}{t10}{t11}</div>;
    $[18] = t11;
    $[19] = t4;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = drop.winning_context?.decision_time || null;
  let t14;
  if ($[22] !== drop.rank || $[23] !== t13) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t13} /></div>;
    $[22] = drop.rank;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t12}{t14}</div>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t3) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t15}</div>;
    $[28] = t15;
    $[29] = t3;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
};
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}